import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ajvirus/Desktop/DTDB_Next/app/faqs/Faqs.js");
